<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex class="mb-4">
                                    <v-label>ID, Código, Nome da unidade de negócio</v-label>
                                    <v-text-field ref="textField" v-model="filtroTexto" flat solo hide-details
                                                  maxlength="100" @keyup.enter="filtrar"></v-text-field>
                                </v-flex>
                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn class="btn-default" color="primary" large :to="{name:'cadastro_unidade_negocio'}">
                            Cadastrar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout column class="card table">
            <data-table ref="table" url="/admin/unidadesnegocio" :filter="dtFiltro" :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td>{{ item.id_unidade_negocio }}</td>
                    <td>{{ item.codigo }}</td>
                    <td>{{ item.nome }}</td>
                    <td width="1%">
                        <v-layout>
                            <v-btn flat icon color="primary" @click="editar(item)">
                                <v-icon>ol-edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="primary" @click="excluir(item)">
                                <v-icon>ol-delete</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'
import { events } from '../plugins/events'

/**
   * @var item
   * @type {object}
   * @property {number} id_unidade_negocio
   * @property {string} codigo
   * @property {string} nome
   */

export default {
  components: { DataTable },
  data: () => ({
    headers: [
      { text: 'ID', value: 'id_unidade_negocio' },
      { text: 'Código', value: 'codigo' },
      { text: 'Nome da Unidade de Negócio', value: 'nome' },
      { value: '', sortable: false }
    ],
    filtroTexto: '',
    dtFiltro: {},
    popupFiltro: false
  }),
  computed: {
    filtro () {
      return {
        'id_unidade_negocio|codigo|nome': this.filtroTexto
      }
    }
  },
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    editar (item) {
      this.$router.push({ name: 'cadastro_unidade_negocio', params: { id_unidade_negocio: `${item.id_unidade_negocio}` } })
    },
    excluir (item) {
      alert({
        text: `Tem certeza que deseja excluir a unidade de negócio${item.nome ? ' ' + item.nome : ''}?`,
        buttons: {
          'Cancelar': () => true,
          'Excluir': () => {
            this.$http.delete(`/admin/unidadesnegocio/${item.id_unidade_negocio}`)
              .then(() => {
                alert(`Unidade de negócio excluída com sucesso!`)
                const id_usuario = this.$session.get('id_usuario')
                events.$emit('atualizar-unidade', id_usuario)
                this.dtFiltro = { ...this.filtro }
              }).catch(err => {
                error(err, 'Não foi possível excluir a unidade de negócio.')
              })
          }
        }
      })
    },
    filtrar () {
      this.popupFiltro = false
      this.dtFiltro = { ...this.filtro }
    },
    limpar () {
      this.filtroTexto = ''
      this.filtrar()
    }
  }
}
</script>

<style scoped>

</style>
